import { useScope } from "@/hooks/useScope";

/**
 * Returns the entity with the given identifier.
 * @param identifier - The identifier of the entity to return.
 * @returns The entity with the given identifier.
 */
export function useEntity(identifier: string) {
  const { entities, scopedActiveEntity, isLoading } = useScope();

  return {
    entity:
      identifier == null
        ? scopedActiveEntity
        : (entities || []).find((entity) => entity.identifier === identifier),
    isLoading,
  };
}
